import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import clsx from "clsx";
import { executeRecaptcha, cleanupRecaptcha } from "../../utils/useRecaptcha";
import * as auth from "../../store/ducks/auth.duck";
import { login, me } from "../../crud/auth.crud";
import { Constants } from "../../utils/Constants";
import MfaVerify from "./MfaVerify";
import Swal from "sweetalert2";
import { getFallBackTimeZone } from "../../utils/Utils";

function Login(props) {
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem",
  });
  const [mfaData, setMfaData] = useState(null);

  useEffect(() => {
    return () => cleanupRecaptcha();
  }, []);

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

  const validateAndStoreUser = async () => {
    try {
      const meRes = await me();
      const meData = meRes.data;

      if (meData.identity?.ctx !== "barbeiro") {
        Swal.fire(
          "Acesso negado",
          "Você não tem permissão para acessar este painel.",
          "error"
        );
        return;
      }

      if (meData.session?.origin !== "web") {
        Swal.fire(
          "Acesso negado",
          "Sessão inválida para este contexto.",
          "error"
        );
        return;
      }

      localStorage.setItem("timeZone", meData.identity?.time_zone ?? getFallBackTimeZone());
      localStorage.setItem(
        "cadastro_agendamento",
        meData.identity?.usu_cadastro_agendamento
      );
      localStorage.setItem(
        "edicao_agendamento",
        meData.identity?.usu_edicao_agendamento
      );
      localStorage.setItem(
        "gerenciar_produtos",
        meData.identity?.usu_gerenciar_produtos
      );
      localStorage.setItem(
        "gerenciar_servicos",
        meData.identity?.usu_gerenciar_servicos
      );
      localStorage.setItem(
        "remocao_folgas",
        meData.identity?.usu_remocao_folgas
      );
      localStorage.setItem(
        "cadastro_horario_bloqueado",
        meData.identity?.usu_cadastro_horario_bloqueado
      );
      localStorage.setItem("edicao_notas", meData.identity?.usu_edicao_notas);

      props.login({ user: meData });
    } catch (err) {
      Swal.fire(
        "Erro",
        "Não foi possível carregar os dados do usuário.",
        "error"
      );
    }
  };

  if (mfaData) {
    return (
      <MfaVerify
        mfaData={mfaData}
        onBack={() => setMfaData(null)}
        onSuccess={validateAndStoreUser}
      />
    );
  }

  return (
    <>
      <div className="kt-login__head"></div>

      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h3>Entrar</h3>
          </div>

          <Formik
            initialValues={{ email: "", password: "" }}
            validate={(values) => {
              const errors = {};

              if (!values.email) {
                errors.email = "O e-mail é uma informação obrigatória.";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Você precisa informar um e-mail válido.";
              }

              if (!values.password) {
                errors.password = "A senha é uma informação obrigatória.";
              }

              return errors;
            }}
            onSubmit={async (values, { setStatus, setSubmitting }) => {
              enableLoading();

              // TODO: Reabilitar reCAPTCHA após segunda-feira
              try {
                // const captchaToken = await executeRecaptcha("LOGIN");
                const res = await login(
                  values.email,
                  values.password,
                  null
                );
                disableLoading();

                if (res.data.mfa_required) {
                  setMfaData(res.data);
                  return;
                }

                await validateAndStoreUser();
              } catch (err) {
                disableLoading();
                setSubmitting(false);

                const errorMessage =
                  err.response?.data?.message ||
                  err.response?.data?.error ||
                  err.message ||
                  "Usuário ou senha incorretos.";
                setStatus(errorMessage);
              }
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
              >
                {status ? (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{status}</div>
                  </div>
                ) : null}

                <div className="form-group">
                  <TextField
                    type="email"
                    label="Seu e-mail"
                    margin="normal"
                    className="kt-width-full"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    helperText={touched.email && errors.email}
                    error={Boolean(touched.email && errors.email)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    type="password"
                    margin="normal"
                    label="Sua senha"
                    className="kt-width-full"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>

                <div>
                  <a className="forgot-password" href="/password/forgot">
                    Esqueceu sua senha?
                  </a>
                </div>

                <div style={{ alignSelf: "baseline", marginTop: 8 }}>
                  <a
                    style={{ display: "block" }}
                    target="_blank"
                    href={Constants.termosUsoURL}
                  >
                    Termos de uso
                  </a>
                  <a target="_blank" href={Constants.politicasPrivacidadeURL}>
                    Políticas de privacidade
                  </a>
                </div>

                <div className="kt-login__actions">
                  <button
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={loading}
                    className={`btn btn-primary btn-elevate kt-login__btn-primary 
                    						${clsx({
                                  "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading,
                                })}`}
                    style={loadingButtonStyle}
                  >
                    Entrar!
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default connect(null, auth.actions)(Login);
